import * as Types from '../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AdaptiveSubjectsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type AdaptiveSubjectsQuery = { __typename?: 'RootQueryType', subjects?: { __typename?: 'KeysetPageOfSubject', results?: Array<{ __typename?: 'Subject', id: string, name: string, urlSlug: string, description?: string | null, logoImageUrl?: string | null, curriculumArea?: { __typename?: 'CurriculumArea', id: string, color: string, name: string } | null }> | null } | null };


export const AdaptiveSubjectsDocument = gql`
    query AdaptiveSubjects {
  subjects(filter: {guides: {type: {eq: "adaptive"}}, hidden: {eq: false}}) {
    results {
      id
      name
      urlSlug
      description
      logoImageUrl
      curriculumArea {
        id
        color
        name
      }
    }
  }
}
    `;

/**
 * __useAdaptiveSubjectsQuery__
 *
 * To run a query within a React component, call `useAdaptiveSubjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAdaptiveSubjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdaptiveSubjectsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAdaptiveSubjectsQuery(baseOptions?: Apollo.QueryHookOptions<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>(AdaptiveSubjectsDocument, options);
      }
export function useAdaptiveSubjectsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>(AdaptiveSubjectsDocument, options);
        }
export function useAdaptiveSubjectsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>(AdaptiveSubjectsDocument, options);
        }
export type AdaptiveSubjectsQueryHookResult = ReturnType<typeof useAdaptiveSubjectsQuery>;
export type AdaptiveSubjectsLazyQueryHookResult = ReturnType<typeof useAdaptiveSubjectsLazyQuery>;
export type AdaptiveSubjectsSuspenseQueryHookResult = ReturnType<typeof useAdaptiveSubjectsSuspenseQuery>;
export type AdaptiveSubjectsQueryResult = Apollo.QueryResult<AdaptiveSubjectsQuery, AdaptiveSubjectsQueryVariables>;